import { render, staticRenderFns } from "./MoveLocationDialog.vue?vue&type=template&id=1d1a4ed8"
import script from "./MoveLocationDialog.vue?vue&type=script&lang=js"
export * from "./MoveLocationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports